module.exports = __webpack_public_path__ + "static/media/survey-fill.08819129.svg";